module.exports = __webpack_public_path__ + "img/pdf.dba07260.png";